export default __webpack_public_path__ + "static/media/36I-117133_-37268_0.0e8f5923.jpg";